import { Pipe, PipeTransform } from '@angular/core';
import { OutlookAiMarkupUtils } from '../iq-boost/utils/ai-markup-utils';

@Pipe({ name: 'outlookEntityKeyRef' })
export class OutlookEntityKeyRefPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) return '';
    return OutlookAiMarkupUtils.stripEntityKeyRefs(value);
  }
}
